import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { themeTokensCss } from '@hew3/shared';
import './styles.css';
import App from './App.tsx';

/**
 * 设计令牌注入：颜色、圆角、字体族只有一处定义（@hew3/shared/src/theme.ts）。
 * 服务方工作台与 C 端 / 员工控制台共用同一套令牌 —— 三端对「危险 / 警示 / 正常」
 * 的颜色语义因此不会各说各话；但**身份与代码是隔离的**（三份独立产物，见 README）。
 */
const tokenStyle = document.createElement('style');
tokenStyle.id = 'hew3-design-tokens';
tokenStyle.textContent = themeTokensCss();
document.head.prepend(tokenStyle);

const container = document.getElementById('root');
if (!container) throw new Error('未找到 #root 挂载点');

createRoot(container).render(
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>,
);
